import { IModularFamily } from '../../../redux/slices/ModularEnrolmentSlice/types';
import { IDependent } from '../../../redux/slices/PolicyListSlice/types';
import { groupArrayOfObjectsByKey } from '../../../utils/common';
import { FamilyMemberSortingPreference } from '../../../utils/constants/ModularConstants';
import { IFamilyStructureSectionRelationship } from '../../../utils/types';
import { IForm } from '../ManageModularMember/types';
import { IDependantDisplayCard, IRadioItem } from './types';

export const initialFormValues: IForm = {
    firstName: '',
    lastName: '',
    dob: '',
    gender: '',
    relationship: '',
    mobile: ''
};

export const sortFamilyMembers = (family: (IModularFamily | IDependent)[]): (IModularFamily | IDependent)[] => {
    return structuredClone(family).sort(
        (a, b) =>
            FamilyMemberSortingPreference[a.relationship?.toLowerCase()] -
            FamilyMemberSortingPreference[b.relationship?.toLowerCase()]
    );
};
export const getDependentDisplayCards = (
    relationships: IFamilyStructureSectionRelationship[],
    membersToDisplay: IModularFamily[],
    maxAllowed: number,
    isAnyOneType: boolean,
    selectedOption: IRadioItem | null
): IDependantDisplayCard[] => {
    const membersByRelation = groupArrayOfObjectsByKey(membersToDisplay, (m) => m.relationship.toLowerCase());
    const relations: IFamilyStructureSectionRelationship[] = isAnyOneType
        ? [relationships[selectedOption?.id ?? 0]]
        : relationships;
    return relations
        .flatMap((r) => {
            const currMembers = r.type
                .flatMap((rel) => membersByRelation[rel.toLowerCase()] ?? [])
                .map((d) => ({
                    dependant: d,
                    relations: r.type,
                    cardLabel: r.label
                })) as IDependantDisplayCard[];
            const rem = Math.max(r.maxAllowed - currMembers.length, 0);
            return currMembers.concat(
                ...Array.from({ length: rem }).map(() => ({ relations: r.type, cardLabel: r.label }))
            );
        })
        .slice(0, maxAllowed);
};
